import React from "react";

interface IQuotesIconProps {
    size?: number;
    color?: string;
    type?: "single" | "double";
}

export const QuotesIcon: React.FC<IQuotesIconProps> = ({ size = 24, color = "black", type = "single" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {type === "single" && <path
                d="M39.2666 68.5901V58.3628C39.2666 55.3443 39.8348 52.1661 40.9711 48.828C42.1075 45.4899 43.6878 42.2939 45.7119 39.2399C47.7361 36.1859 50.1153 33.5759 52.8497 31.4097L60.7332 37.056C58.567 40.2165 56.7204 43.519 55.1934 46.9636C53.6665 50.4082 52.903 54.1547 52.903 58.203V68.5901H39.2666Z"
                fill={color}/>}
            {type === "double" && <path
                d="M25.6836 68.5901V58.3628C25.6836 55.3443 26.2518 52.1661 27.3881 48.828C28.5245 45.4899 30.1048 42.2939 32.1289 39.2399C34.1531 36.1859 36.5323 33.5759 39.2667 31.4097L47.1502 37.056C44.984 40.2165 43.1374 43.519 41.6104 46.9636C40.0835 50.4082 39.32 54.1547 39.32 58.203V68.5901H25.6836ZM52.8498 68.5901V58.3628C52.8498 55.3443 53.418 52.1661 54.5543 48.828C55.6907 45.4899 57.271 42.2939 59.2951 39.2399C61.3192 36.1859 63.6985 33.5759 66.4329 31.4097L74.3164 37.056C72.1502 40.2165 70.3036 43.519 68.7766 46.9636C67.2496 50.4082 66.4862 54.1547 66.4862 58.203V68.5901H52.8498Z"
                fill={color}/>}
        </svg>
    );
};
